import axios from 'axios';

const weatherToken = process.env.REACT_APP_OPEN_WEATHER;
const baseURL = `https://api.openweathermap.org/data/2.5/weather?lat=9.9911&lon=-83.0408&appid=${weatherToken}&units=metric&lang=es`;

export const getWeatherData = () => {
  return axios.get(baseURL);
};
